<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-lg-6 col-md-8 col-8 col-12">
        <div class="login-main-section">
          <div class="inner">
            <div class="logo">
              <img class="img-fluid" src="@/assets/images/logo.svg" alt="">
            </div>

            <form @submit="login">
              <input class="form-control" placeholder="Username" v-model="username" type="text"> <br>
              <input class="form-control" placeholder="Password" v-model="password" type="password"> <br>
              <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="form-control submit-btn mb-4">
                <div v-if="this.$store.getters.apiStatus != 'loading'">Log in</div>
                <div v-else class="loader"><Loader></Loader></div>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>

    <div class="row justify-content-center">
      <div class="col-lg-6 footer d-block">
        <p>© {{year}} S. Martinelli & Company <br class="mobile"> Image Library – All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      year: new Date().getFullYear()
    }
  },
  mounted () {
    $('#app').addClass('login-page')
    $('header').addClass('d-none')
  },
  beforeDestroy: function () {
    $('#app').removeClass('login-page')
    $('header').removeClass('d-none')
  },
  methods: {
    login (event) {
      event.preventDefault()
      let username = this.username
      let password = this.password
      this.$store.dispatch('login', { username, password })
        .then(() => {
          this.$router.push('/')
          this.$toast.success('Logged in successfully')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}
</script>

<style>
.login-page .footer {
  display: none;
}
</style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Login.vue